/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/prop-types */
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, ModalProps, Typography, Popover, Row, Col, Button, notification, Checkbox } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCredentials, selectInsuranceArray } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import { YJTBQuery, YJTBQueryRef } from './query'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { YJTBXJDKCAGColumns, YJTBXJDSJAGColumns } from './columns'
import { getOneClickSyncCatalogAsync, getoneClickSyncInventoryAsync, getpageCommodityListAsync } from './commoditySlice'
import { getPageStoresearchAsync } from '../storesearch/storesearchSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
const { Text } = Typography

export const YJTBXJDMLKCModal = (props: {
  onOk: () => void,
  onCancel: () => void,
  visible: boolean,
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const ref = useRef<YJTBQueryRef>(null)

  const [pageLoading, setPageLoading] = useState<any>(false)

  const [data, setData] = useState<any>({
    list: [],
    total: 0,
  })

  const [TBLoading, setTBLoading] = useState<any>(false)

  const [AllTBLoading, setAllTBLoading] = useState<any>(false)

  const [sureVisible, setSureVisible] = useState<any>(false)

  const [allTB, setAllTB] = useState<any>(false)

  const [isChecked, setIsChecked] = useState<any>(false)

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '商品信息',
      field: 'name',
      minWidth: 370,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '所属库房',
      field: 'storehouseName',
      minWidth: 260,
      visible: true,
    },
    {
      headerName: '批号',
      field: 'batchNo',
      minWidth: 70,
      visible: true,
    },
    {
      headerName: '目录售价',
      field: 'catalogRetailPrice',
      minWidth: 70,
      visible: true,
    },
    {
      headerName: '库存售价',
      field: 'retailPrice',
      minWidth: 70,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [queries, setQueries] = useState({
    current: 1,
    size: 10,
  })

  const [selectIds, setSelectIds] = useState<any>([]) //选中行的id数组

  const [selectRows, setSelectRows] = useState<any>([]) //选中行的数据

  const [pageSelections, setPageSelections] = useState<any>({})

  const [ids, setIds] = useState('') //选中行的id合并成字符串

  useEffect(() => {
    if (props?.visible) {
      getPage()
      getPageColumnList()
    }
  }, [props?.visible, queries])

  useEffect(() => {
    if (sureVisible) {
      const SFSCBDJLHTJJL = localStorage?.getItem('SFSCBDJLHTJJL')
      setIsChecked(SFSCBDJLHTJJL == 'true' ? true : false)
    }
  }, [sureVisible])

  const getPage = () => {
    setPageLoading(true)
    dispatch(getPageStoresearchAsync({
      ...queries,
      showFlag: 0,
      mergeFlag: 0,
      state: 1,
      notSamePriceFlag: true,
      deadlineFlag: true,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        setData({
          list: v?.records || [],
          total: v?.total || 0,
        })
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (JSON.stringify(pageSelections) != '{}') {
      const derivedSelectedKeys = Object.values(pageSelections).flat()
      const selectedRowIds = derivedSelectedKeys.map((row: any) => Number(row?.id))
      setSelectIds(selectedRowIds || [])
      setIds(selectedRowIds?.join(','))
      setSelectRows(derivedSelectedKeys)
    }
  }, [pageSelections])

  useEffect(() => {
    if (!selectIds?.length) {
      setPageSelections({})
    }
  }, [selectIds]);

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'YJTBXJDMLKCModal',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      }).finally(() => {
        setPageLoading(false)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'YJTBXJDMLKCModal',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
  }

  const resetData = () => {
    setSelectIds([])
    setPageSelections({})
    setIds('')
    setSelectRows([])
    setData({
      list: [],
      total: 0,
    })
    setQueries({
      current: 1,
      size: 10,
    })
  }

  useEffect(() => {
    if (!props?.visible) {
      resetData()
      ref?.current?.reset()
      setAllTB(false)
    }
  }, [props?.visible])

  return (
    <>
      <Modal
        title='一键同步售价到库存'
        visible={props?.visible}
        onOk={props?.onOk}
        onCancel={props?.onCancel}
        maskClosable={false}
        width={1000}
        footer={null}
        bodyStyle={{
          height: 680,
          padding: '10px 15px 10px 15px',
          overflowY: 'auto',
        }}
      >
        <YJTBQuery
          ref={ref}
          yjtbdkc={1} // 同步到库存
          selectIds={selectIds}
          loading={pageLoading}
          filterColumn={allColumnList} //筛选列
          filterSelectList={filterSelectList}
          submitPageList={((v) => {
            setPageLoading(true)
            submitPageList(v)
            setAllColumnList(v)
          })}
          onValueChange={(v) => {
            setQueries({
              ...queries,
              ...v,
              current: 1,
              size: 10,
            })
          }}
        />
        <div style={{ height: '570px' }}>
          <SimpleAgGrid
            rowHeight={56}
            page={{
              size: queries.size || 10,
              current: queries.current || 1,
              total: data?.total || 0,
              items: data?.list || [],
            }}
            column={
              YJTBXJDKCAGColumns(
                (queries.size || 10) * ((queries.current || 1) - 1),
                allColumnList
              )?.filter((item: any) => filterSelectList?.includes(item.field))
            }
            isLoading={pageLoading}
            pagination={true}
            pageKey={'YJTBXJDMLKCModal'}
            rowSelection="multiple"
            selectedRowKeys={selectIds}
            getRowId={(data: any) => data?.id}
            onSelectionChange={(selectedRows: any, selectedNodes: any) => {
              // 更新当前页面的选中状态
              const currentPage: any = queries.current;
              setPageSelections((prev: any) => ({
                ...prev,
                [currentPage]: selectedRows
              }));
            }}
            suppressRowClickSelection={true}
            onChangePage={(current, size: any) => {
              setQueries({
                ...queries,
                current,
                size,
              })
            }}
            onColumnResized={(v) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
        </div>
        <Row style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
          <Button style={{ marginRight: 10 }} onClick={() => props?.onCancel()}>取消</Button>
          <Button
            style={{ marginRight: 10 }}
            loading={AllTBLoading}
            type='primary'
            ghost
            onClick={(() => {
              setAllTB(true)
              setSureVisible(true)
            })}>全部同步</Button>
          <Button
            style={{ marginRight: 10 }}
            loading={TBLoading}
            type='primary'
            onClick={(() => {
              if (!ids?.length) {
                notification.info({
                  message: '请选择要同步的数据',
                })
              } else {
                setAllTB(false)
                setSureVisible(true)
              }
            })}>确认同步</Button>
        </Row>
      </Modal>
      <Modal
        width={500}
        title={allTB ? '全部同步' : '确认操作'}
        confirmLoading={allTB ? AllTBLoading : TBLoading}
        destroyOnClose
        visible={sureVisible}
        onCancel={() => setSureVisible(false)}
        onOk={() => {
          // 全部同步
          if (allTB) {
            setAllTBLoading(true)
            dispatch(getoneClickSyncInventoryAsync({
              syncAllFlag: true,
              flag: isChecked ? 1 : 0,
            }))
              .then(unwrapResult)
              .then((res: any) => {
                notification.success({
                  message: res || '操作成功',
                })
              })
              .finally(() => {
                resetData()
                setAllTBLoading(false)
                setSureVisible(false)
                props?.onOk()
              })
          } else {
            setTBLoading(true)
            const syncInventoryDTOList = selectRows?.map((v: any) => ({
              id: v?.tenantMaterialsCatalogId,
              retailPrice: v?.catalogRetailPrice,
              inventoryId: v?.id,
              flag: isChecked ? 1 : 0,
            }))
            dispatch(getoneClickSyncInventoryAsync({
              syncInventoryDTOList: syncInventoryDTOList,
            }))
              .then(unwrapResult)
              .then((res: any) => {
                notification.success({
                  message: res || '操作成功',
                })
              })
              .catch(() => {
                resetData()
              })
              .finally(() => {
                resetData()
                setTBLoading(false)
                setSureVisible(false)
                props?.onOk()
              })
          }
        }}
      >
        <div style={{ paddingLeft: '10px' }}>
          <div style={{ display: 'flex' }}>
            <ExclamationCircleFilled
              style={{
                color: '#FFAE55',
                fontSize: 18,
              }}
            />
            <div style={{ margin: '-4px 0 0 10px' }}>
              <div> {allTB ? '确认全部同步吗？' : '确认同步选中的数据吗？'}</div>
            </div>
          </div>
          <Checkbox
            checked={isChecked}
            onChange={() => {
              setIsChecked(!isChecked)
              localStorage.setItem('SFSCBDJLHTJJL', JSON.stringify(!isChecked))
            }}
            style={{ margin: '10px 0', position: 'absolute', bottom: '4px' }}
          >
            生成调价记录
          </Checkbox>
        </div>
      </Modal>
    </>
  )
}
